import { axios } from "../axios.instance";

export type RefreshTokenRequest = {
  refreshToken: string;
};

export type RefreshTokenResponse = {
  accessToken: string;
  refreshToken: string;
};

export const refreshAccessToken = async (body: RefreshTokenRequest): Promise<RefreshTokenResponse> => {
  const { data } = await axios.post("auth/refresh-token", body);

  return data;
};
